import React from 'react'

import { PageHeader } from "../../shared/ui";


export default function PromoPage() {
  return (
    <>
    <PageHeader placeholder={"Пошук за назвою, артикулом (SKU), тегом"}/>
    <section className="section-admin">
      
    </section>
    </>
  );
}
